import Button from '@mui/material/Button';
import Stack from '@mui/material/Stack';
import Typography from '@mui/material/Typography';
import { styles } from '../../styles';

interface INavigationButtonsProps {
  handlePageChange: (page: number) => void;
  currentPage: number;
  pageSize: number;
  totalElements: number;
}

export const NavigationButtons = ({
  handlePageChange,
  currentPage,
  pageSize,
  totalElements,
}: INavigationButtonsProps) => {
  const totalPages = Math.ceil(totalElements / pageSize);
  const isPrevDisabled = currentPage === 0;
  const isNextDisabled = currentPage >= totalPages - 1;

  return (
    <Stack direction="row" spacing={0} sx={styles.tableNavigationButtons}>
      <Button
        variant="outlined"
        onClick={() => handlePageChange(currentPage - 1)}
        disabled={isPrevDisabled}
      >
        Попередня
      </Button>

      <Typography variant="body2" sx={styles.tableNavigationText}>
        Сторінка {currentPage + 1}
      </Typography>

      <Button
        variant="outlined"
        onClick={() => handlePageChange(currentPage + 1)}
        disabled={isNextDisabled}
      >
        Наступна
      </Button>
    </Stack>
  );
};
